import About from "./components/About"
import Header from "./components/Header"
import Showcase from "./components/Showcase"
import Footer from "./components/Footer"

const App = () => {
  return (
    <>
      <Header />
      <Showcase />
      <About />
      <Footer />
      
    </>
  )
}

export default App;
